import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import SmartStudyLineChart from "../../components/smart/StudyLineChart/StudyLineChart";
import { ProfileCard } from "../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../components/smart/PageHeader/PageHeader";
import StudyEntriesDatepicker from "../../components/smart/StudyEntriesDatepicker/StudyEntriesDatepicker";
import StudyEntriesTable from "../../components/smart/StudyEntriesTable/StudyEntriesTable";
import SmartTargets from "../../components/smart/Targets/Targets";
import { mapStateToPropsLogin } from "../../modules/login";
import { useTranslation } from "react-i18next";

const PanelsWrapper = styled.div`
  margin-left: 0px;
  margin-right: 0px;
  display: flex;

  & > div {
    margin-right: 15px;
    margin-bottom: 15px;
    min-width: 375px;
    flex: 0;
    &.chart-wrapper {
      flex: 1;
      margin-left: 0px;
      height: 100%;
    }
  }

  @media (max-width: 1450px) {
    flex-direction: column;
    & > .chart-wrapper {
      margin-left: 0;
    }
  }

  @media (max-width: 768px) {
    & > div {
      margin-right: 0;
    }
  }

  @media (max-width: 374px) {
    & > div {
      min-width: 320px;
    }
  }
`;

const Stats = (props) => {
  const {
    route: { study },
    match: {
      params: { participantId },
    },
    userData,
    studyEntriesDatePicker: { formattedDateRange = undefined } = {},
    loginReducer: { studies },
    canViewTargetPanel,
  } = props;

  const { t } = useTranslation();

  const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (update) {
      setUpdate(false);
    }
  }, [update]);

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        participantId={participantId}
        shouldFetchParticipant={true}
        studyId={study}
      />

      <StudyEntriesDatepicker
        {...{ study }}
        {...{ participantId }}
        dateRange={formattedDateRange}
      />

      <PanelsWrapper>
        {canViewTargetPanel && (
          <div className="targets-wrapper">
            <SmartTargets
              {...{ participantId }}
              update={update}
              dateRange={formattedDateRange}
              userData={userData}
              studyId={study}
            />
          </div>
        )}

        <div className="chart-wrapper">
          <ProfileCard
            title={t("contentText.dietDiary.macronutrientsChart.title")}
            showIcon={false}
            removePadding={true}
          >
            <SmartStudyLineChart
              {...{ study }}
              update={update}
              {...{ participantId }}
              dateRange={formattedDateRange}
            />
          </ProfileCard>
        </div>
      </PanelsWrapper>

      <div className="mt-5">
        <ProfileCard
          title={t("contentText.dietDiary.entriesTable.title")}
          showIcon={false}
        >
          <StudyEntriesTable
            {...{ study }}
            {...{ participantId }}
            userData={userData}
            dateRange={formattedDateRange}
            onUpdate={() => setUpdate(true)}
          />
        </ProfileCard>
      </div>
    </>
  );
};

export default withTheme(
  connect((state) => {
    return {
      ...mapStateToPropsLogin(state),
      studyEntriesDatePicker: state?.studyEntriesDatePickerReducer,
      userData: state?.smartPageHeaderReducer,
      loginReducer: state?.loginReducer,
    };
  })(Stats)
);
